const shapeType = require('../../define/shapeType').default;
const rotateType = require('../../define/rotate').default;
// =======================
function getRectShapeArray(rotate) {
    switch (rotate) {
        case rotateType.ROTATE_DEFAULT:
            /**
             * [ ][ ][ ][ ]
             * [ ][1][2][ ]
             * [ ][3][4][ ]
             * [ ][ ][ ][ ]
             */
            return [{ posX: 1, posY: 1 }, { posX: 2, posY: 1 }, { posX: 1, posY: 2 }, { posX: 2, posY: 2 }]
        case rotateType.ROTATE_90:
            /**
            * [ ][ ][ ][ ]
            * [ ][3][1][ ]
            * [ ][4][2][ ]
            * [ ][ ][ ][ ]
            */
            return [{ posX: 2, posY: 1 }, { posX: 2, posY: 2 }, { posX: 1, posY: 1 }, { posX: 1, posY: 2 }]
        case rotateType.ROTATE_180:
            /**
            * [ ][ ][ ][ ]
            * [ ][4][3][ ]
            * [ ][2][1][ ]
            * [ ][ ][ ][ ]
            */
            return [{ posX: 2, posY: 2 }, { posX: 1, posY: 2 }, { posX: 2, posY: 1 }, { posX: 1, posY: 1 }]
        case rotateType.ROTATE_270:
            /**
            * [ ][ ][ ][ ]
            * [ ][2][4][ ]
            * [ ][1][3][ ]
            * [ ][ ][ ][ ]
            */
            return [{ posX: 1, posY: 2 }, { posX: 1, posY: 1 }, { posX: 2, posY: 2 }, { posX: 2, posY: 1 }]
        default:
            return null;
    }
}

function getStickShapeArray(rotate) {
    switch (rotate) {
        case rotateType.ROTATE_DEFAULT:
            /**
             * [ ][ ][ ][ ]
             * [1][2][3][4]
             * [ ][ ][ ][ ]
             * [ ][ ][ ][ ]
             */
            return [{ posX: 0, posY: 1 }, { posX: 1, posY: 1 }, { posX: 2, posY: 1 }, { posX: 3, posY: 1 }]
        case rotateType.ROTATE_90:
            /**
            * [ ][ ][1][ ]
            * [ ][ ][2][ ]
            * [ ][ ][3][ ]
            * [ ][ ][4][ ]
            */
            return [{ posX: 2, posY: 0 }, { posX: 2, posY: 1 }, { posX: 2, posY: 2 }, { posX: 2, posY: 3 }]
        case rotateType.ROTATE_180:
            /**
            * [ ][ ][ ][ ]
            * [ ][ ][ ][ ]
            * [4][3][2][1]
            * [ ][ ][ ][ ]
            */
            return [{ posX: 3, posY: 2 }, { posX: 2, posY: 2 }, { posX: 1, posY: 2 }, { posX: 0, posY: 2 }]
        case rotateType.ROTATE_270:
            /**
            * [ ][4][ ][ ]
            * [ ][3][ ][ ]
            * [ ][2][ ][ ]
            * [ ][1][ ][ ]
            */
            return [{ posX: 1, posY: 3 }, { posX: 1, posY: 2 }, { posX: 1, posY: 1 }, { posX: 1, posY: 0 }]
        default:
            return null;
    }
}

function getCrossShapeArray(rotate) {
    switch (rotate) {
        case rotateType.ROTATE_DEFAULT:
            /**
             * [ ][ ][ ][ ]
             * [ ][1][ ][ ]
             * [2][3][4][ ]
             * [ ][ ][ ][ ]
             */
            return [{ posX: 1, posY: 1 }, { posX: 0, posY: 2 }, { posX: 1, posY: 2 }, { posX: 2, posY: 2 }]
        case rotateType.ROTATE_90:
            /**
            * [ ][2][ ][ ]
            * [ ][3][1][ ]
            * [ ][4][ ][ ]
            * [ ][ ][ ][ ]
            */
            return [{ posX: 2, posY: 1 }, { posX: 1, posY: 0 }, { posX: 1, posY: 1 }, { posX: 1, posY: 2 }]
        case rotateType.ROTATE_180:
            /**
            * [ ][ ][ ][ ]
            * [ ][4][3][2]
            * [ ][ ][1][ ]
            * [ ][ ][ ][ ]
            */
            return [{ posX: 2, posY: 2 }, { posX: 3, posY: 1 }, { posX: 2, posY: 1 }, { posX: 1, posY: 1 }]
        case rotateType.ROTATE_270:
            /**
            * [ ][ ][ ][ ]
            * [ ][ ][4][ ]
            * [ ][1][3][ ]
            * [ ][ ][2][ ]
            */
            return [{ posX: 1, posY: 2 }, { posX: 2, posY: 3 }, { posX: 2, posY: 2 }, { posX: 2, posY: 1 }]
        default:
            return null;
    }
}

function getLLineShapeArray(rotate) {
    switch (rotate) {
        case rotateType.ROTATE_DEFAULT:
            /**
             * [ ][ ][ ][ ]
             * [ ][1][ ][ ]
             * [ ][2][3][4]
             * [ ][ ][ ][ ]
             */
            return [{ posX: 1, posY: 1 }, { posX: 1, posY: 2 }, { posX: 2, posY: 2 }, { posX: 3, posY: 2 }]
        case rotateType.ROTATE_90:
            /**
            * [ ][ ][ ][ ]
            * [ ][2][1][ ]
            * [ ][3][ ][ ]
            * [ ][4][ ][ ]
            */
            return [{ posX: 2, posY: 1 }, { posX: 1, posY: 1 }, { posX: 1, posY: 2 }, { posX: 1, posY: 3 }]
        case rotateType.ROTATE_180:
            /**
            * [ ][ ][ ][ ]
            * [4][3][2][ ]
            * [ ][ ][1][ ]
            * [ ][ ][ ][ ]
            */
            return [{ posX: 2, posY: 2 }, { posX: 2, posY: 1 }, { posX: 1, posY: 1 }, { posX: 0, posY: 1 }]
        case rotateType.ROTATE_270:
            /**
            * [ ][ ][4][ ]
            * [ ][ ][3][ ]
            * [ ][1][2][ ]
            * [ ][ ][ ][ ]
            */
            return [{ posX: 1, posY: 2 }, { posX: 2, posY: 2 }, { posX: 2, posY: 1 }, { posX: 2, posY: 0 }]
        default:
            return null;
    }
}

function getSLineShapeArray(rotate) {
    switch (rotate) {
        case rotateType.ROTATE_DEFAULT:
            /**
             * [ ][ ][ ][ ]
             * [1][2][ ][ ]
             * [ ][3][4][ ]
             * [ ][ ][ ][ ]
             */
            return [{ posX: 0, posY: 1 }, { posX: 1, posY: 1 }, { posX: 1, posY: 2 }, { posX: 2, posY: 2 }]
        case rotateType.ROTATE_90:
            /**
            * [ ][ ][1][ ]
            * [ ][3][2][ ]
            * [ ][4][ ][ ]
            * [ ][ ][ ][ ]
            */
            return [{ posX: 2, posY: 0 }, { posX: 2, posY: 1 }, { posX: 1, posY: 1 }, { posX: 1, posY: 2 }]
        case rotateType.ROTATE_180:
            /**
            * [ ][ ][ ][ ]
            * [ ][4][3][ ]
            * [ ][ ][2][1]
            * [ ][ ][ ][ ]
            */
            return [{ posX: 3, posY: 2 }, { posX: 2, posY: 2 }, { posX: 2, posY: 1 }, { posX: 1, posY: 1 }]
        case rotateType.ROTATE_270:
            /**
            * [ ][ ][ ][ ]
            * [ ][ ][4][ ]
            * [ ][2][3][ ]
            * [ ][1][ ][ ]
            */
            return [{ posX: 1, posY: 3 }, { posX: 1, posY: 2 }, { posX: 2, posY: 2 }, { posX: 2, posY: 1 }]
        default:
            return null;
    }
}

function getShapeArrayPosition(type, rotate) {
    switch (type) {
        case shapeType.SHAPE_RECT:
            return getRectShapeArray(rotate);
        case shapeType.SHAPE_STICK:
            return getStickShapeArray(rotate);
        case shapeType.SHAPE_CROSS:
            return getCrossShapeArray(rotate);
        case shapeType.SHAPE_L_LINE:
            return getLLineShapeArray(rotate);
        case shapeType.SHAPE_S_LINE:
            return getSLineShapeArray(rotate);
        default:
            return null;
    };
}

function getRectShapeRelativePosition(rotate) {
    switch (rotate) {
        case rotateType.ROTATE_DEFAULT:
            return 3;
        case rotateType.ROTATE_90:
            return 1;
        case rotateType.ROTATE_180:
            return 0;
        case rotateType.ROTATE_270:
            return 2;
        default:
            return 0;
    }
}

function getShapeAreaRelativePosition(type, rotate) {
    const shapeArray = getShapeArrayPosition(type, rotate);
    let centerIndex = 0;
    switch (type) {
        case shapeType.SHAPE_RECT:
            centerIndex = getRectShapeRelativePosition(rotate);
            break;
        case shapeType.SHAPE_STICK:
            centerIndex = 1;
            break;
        case shapeType.SHAPE_CROSS:
            centerIndex = 2;
            break;
        case shapeType.SHAPE_L_LINE:
            centerIndex = 1;
            break;
        case shapeType.SHAPE_S_LINE:
            centerIndex = 1;
            break;
    }
    const center = shapeArray[centerIndex];
    return shapeArray.map(shape => {
        return { posX: shape.posX - center.posX, posY: shape.posY - center.posY };
    });
}

export default {
    getShapeArrayPosition,
    getShapeAreaRelativePosition
}